import React, { useEffect } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import { translate } from 'containers/services/translate';
import upload from 'images/upload.svg';
import {
  uploadClick as uploadDocumentOnClick,
  fileSelectHandler,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import Document from 'components/Document';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { useDispatch } from 'react-redux';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { handleOpenDocument } from 'services/utils';
import { get, isNil } from 'lodash';
import {
  requestGetDocByDocumentumId,
  requestSetDocumentContent,
} from 'containers/common/UploadDocument/actions';

export interface UploadDocumentProps {
  intl: IntlShape;
  index: number;
  docId?: string;
  name: string;
  type: string;
  documentState: any;
  setDocumentState: Function;
  setDocumentId?: Function;
  shouldDisplay?: boolean;
  shouldNotDisplayUploadTitle?: boolean;
  shouldNotCallReset?: boolean;
  handleDeleteDocument?: Function;
}

export const UploadDocument: React.FC<UploadDocumentProps> = (
  props,
): JSX.Element => {
  const fileRef: React.RefObject<HTMLInputElement> = React.createRef();
  const shouldDisplayDocument = () =>
    (!isNil(get(props.documentState, `[${props.index}].content`, null)) &&
      isNil(get(props.documentState, `[${props.index}].documentumId`, null))) ||
    !isNil(get(props.documentState, `[${props.index}].documentumId`, null));
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(requestSetDocumentContent(null));
  }, [props.type, props.documentState]);
  const handleOpenDocumentumFile = (payload: any) => {
    dispatch(requestGetDocByDocumentumId(payload));
  };
  const handleChangeDocument = (document: any) => {
    dispatch(requestSetDocumentContent(document));
    props.setDocumentState({
      type: props.type,
      name: props.name,
      content: get(document.split('base64,'), '[1]'),
    });
  };

  return (
    <section className="upload-document">
      {!shouldDisplayDocument() && (
        <>
          {!props.shouldNotDisplayUploadTitle && (
            <div className="upload-doc-title">
              {props.shouldDisplay &&
                translate(messages.uploadDocumentTitle, props)}
            </div>
          )}
          <PrimaryButton
            className="upload-document-button"
            onClick={uploadDocumentOnClick(fileRef)}
            lefticon={<img className="cloud-icon" src={upload} alt="" />}
            title={translate(messages.uploadDocumentButtonTitle, props)}
          />
        </>
      )}
      {shouldDisplayDocument() && (
        <Document
          name={props.name}
          type={props.type}
          icon={
            !isNil(
              get(props.documentState, `[${props.index}].documentumId`, null),
            ) ? (
              <div style={{ display: 'flex' }}>
                <VisibilityIcon
                  className="consult"
                  onClick={handleOpenDocument(
                    get(props.documentState, `[${props.index}]`, {}) as any,
                    handleOpenDocumentumFile,
                  )}
                />
                <DeleteOutlineIcon
                  data-testid="delete-icon"
                  style={{ marginLeft: '12px' }}
                  onClick={() => {
                    if (props.handleDeleteDocument)
                      props.handleDeleteDocument(
                        get(props.documentState, `[${props.index}]`, {}),
                      );
                  }}
                />
              </div>
            ) : (
              <></>
            )
          }
        />
      )}
      <input
        id="selectImage"
        type="file"
        onChange={fileSelectHandler(
          handleChangeDocument,
          {
            intl: props.intl,
            docId: props.docId as string,
            setDocumentId: props.setDocumentId,
          },
          true,
        )}
        ref={fileRef}
        hidden
      />
    </section>
  );
};

export default injectIntl(UploadDocument);

UploadDocument.defaultProps = {
  shouldDisplay: true,
};
